import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import cn from 'clsx'
import type { TCounterProps } from './Counter.types'
import styles from './Counter.module.css'

const counter = cva(styles.counter, {
    variants: {
        size: {
            small: styles['size-small'],
            large: styles['size-large'],
        },
    },
    defaultVariants: { size: 'small' },
})

export const Counter = forwardRef<HTMLSpanElement, TCounterProps>(
    ({ className, count, label, Icon, size = 'small', ...props }, ref) => (
        <span ref={ref} className={cn(counter({ size }), className)} {...props}>
            <Icon className={styles.icon} />
            {label ?? count}
        </span>
    ),
)
